import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = user
  const [isAdmin, setIsAdmin] = useState(!!localStorage.getItem("tvverse_admin_token"));

  useEffect(() => {
    const token = localStorage.getItem("tvverse_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data.user))
      .catch(() => {
        localStorage.removeItem("tvverse_token");
        setUser(false);
      });
  }, []);

  const login = (token, u) => {
    localStorage.setItem("tvverse_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("tvverse_token");
    setUser(false);
  };
  const adminLogin = (token) => {
    localStorage.setItem("tvverse_admin_token", token);
    setIsAdmin(true);
  };
  const adminLogout = () => {
    localStorage.removeItem("tvverse_admin_token");
    setIsAdmin(false);
  };

  const value = useMemo(
    () => ({ user, setUser, login, logout, isAdmin, adminLogin, adminLogout }),
    [user, isAdmin]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
